import { State } from '../state';

export const TrendExportSelectors = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    trendExportUrl: (state: State) => state.TrendExport.url,
    trendExportLoading: (state: State): boolean => state.TrendExport.loading,
};
